<sigv-address-selector
  [(ngModel)]="model"
  (ngModelChange)="onAddressValueChange($event)"
  [readonly]="isReadOnly"
  [isRequired]="isRequired"
  [addressControl]="level1"
  [level5MaxLength]="level5MaxLength"
></sigv-address-selector>
